<script lang="ts">
	import ServiceUnavailable from '$components/error/ServiceUnavailable.svelte';
</script>

<ServiceUnavailable />
